// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"50d5933b","453":"3023eaad"}[chunkId] + ".chunk.js";
};